// Import angular modules
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StorageModule } from '@ngx-pwa/local-storage';
import { DecimalPipe, PercentPipe, CurrencyPipe, CommonModule } from '@angular/common';

// Centralized state management
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';

// Import routing
import { AppRoutingModule } from './app-routing.module';

// Import app component
import { AppComponent } from './app.component';

// Import modules
import { PipesModule } from './pipes/pipes.module';
import { ComponentsModule } from './components/components.module';
import { TablesModule } from './tables/tables.module';
import { TabViewModule } from './tab-view/tab-view.module';
import { MenuBarModule } from './menu-bar/menu-bar.module';

// Import modal and loader
import { ModalModule } from './modal/modal.module';
import { LoaderModule } from './loader/loader.module';

// Set locale
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
registerLocaleData(localeNl, 'nl');

// Import components
import { MenuComponent } from './menu/menu.component';
import { TabViewContainerComponent } from './tab-view-container/tab-view-container.component';
import { InfoPageComponent } from './info-page/info-page.component';
import { MessageContainerComponent } from './message-container/message-container.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { OpenProjectComponent } from './open-project/open-project.component';
import { FooterBarComponent } from './footer-bar/footer-bar.component';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { CalculationEffects } from './state-management/calculation-effects';
import { reducers } from './state-management/app-state';
import { UndoRedo } from './state-management/undo-redo';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

export const undoRedo = new UndoRedo();

// Declare modules
@NgModule({ declarations: [
        AppComponent,
        MenuComponent,
        TabViewContainerComponent,
        InfoPageComponent,
        MessageContainerComponent,
        SideMenuComponent,
        OpenProjectComponent,
        FooterBarComponent
    ],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        PipesModule,
        ComponentsModule,
        TablesModule,
        TabViewModule,
        MenuBarModule,
        BrowserAnimationsModule,
        CommonModule,
        ModalModule.forRoot(),
        LoaderModule.forRoot(),
        StorageModule.forRoot({ IDBNoWrap: false }),
        ScrollingModule,
        BrowserModule,
        MatFormFieldModule,
        MatSelectModule,
        StoreModule.forRoot(reducers, {
            metaReducers: [undoRedo.metaReducer.bind(undoRedo)],
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
            }
        }),
        EffectsModule.forRoot([
            CalculationEffects,
            // LoggingEffects
        ]),
        !environment.production ? StoreDevtoolsModule.instrument() : []], providers: [
        PercentPipe,
        DecimalPipe,
        CurrencyPipe,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
